import * as yup from "yup";

export const manualPaymentSchema = yup.object().shape({
  value: yup
    .number()
    .typeError("Valor é obrigatório")
    .required("Valor é obrigatório")
    .min(0, "Valor deve ser maior ou igual a zero"),
  payment_date: yup.string().required("Data do pagamento é obrigatória"),
  payment_method: yup.string().required("Método de pagamento é obrigatório"),
  description: yup
    .string()
    .max(255, "Descrição deve ter no máximo 255 caracteres")
    .default(""),
});
